export const SuggestionCardSkeleton = () => {
  return (
    <div className="flex flex-col border rounded-lg p-4 gap-2">
      <div className="border rounded-lg h-4 loader-pulse bg-neutral-400" />
      <div className="border rounded-lg h-8 loader-pulse bg-neutral-400" />
    </div>
  )
}
